<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-02 17:34:25
 * @FilePath: 
 * @Description: 自助结账
-->
<template>
  <div>
    <div class="search_con">
      <div class="f-1">
        <van-search
          v-model="inputCardValue"
          shape="round"
          placeholder="请输入待结手牌"
        >
        </van-search>
      </div>

      <van-button
        color="var(--tc)"
        size="small"
        round
        @click="handleAddCard"
        :loading="isSubmiting"
        loading-text="添加中"
        >添加手牌</van-button
      >
    </div>
    <ul class="card_list_con">
      <li
        class="card-view-item f-bt"
        v-for="(item, index) in cardList"
        :key="item.code"
      >
        <div class="">
          <img src="@/assets/images/card-icon.png" />
          {{ item.code }}
        </div>
        <div @click="handleRemoveCard(index)">
          <van-icon name="clear" size="20" color="#DCC494" />
          <!-- <uni-icons type="minus" size="26" color="#DCC494"></uni-icons> -->
        </div>
      </li>
    </ul>
    <div class="card_footer">
      <van-button
        color="var(--tc)"
        round
        block
        @click="handleBindCard"
        :disabled="isDisabled"
        >确定</van-button
      >
    </div>
  </div>
</template>

<script>
import { getCardInfo } from "@/api/scan.js";
export default {
  name: "SettleAccounts",
  props: {},
  data() {
    return {
      isSubmiting: false,
      inputCardValue: "",
      cardList: [],
    };
  },
  components: {},
  computed: {
    isDisabled() {
      return this.cardList.length == 0;
    },
  },
  created() {
    this.vpnCode = this.$store.state.vpnInfo.code;
    this.cardList = this.$pub.getS("settleHandList") || [];
  },
  mounted() {},
  methods: {
    handleAddCard() {
      if (!this.inputCardValue.trim()) {
        return this.$toast("手牌号不能为空");
      }
      let hasId = this.cardList.find(
        (item) => item.code == this.inputCardValue
      );
      if (hasId) {
        this.$toast("该手牌号已添加");
      } else {
        this.isSubmiting = true;
        getCardInfo({
          Code: this.inputCardValue,
          SaasVpnCode: this.vpnCode,
        })
          .then((res) => {
            this.isSubmiting = false;
            this.cardList.push({
              code: this.inputCardValue,
              checkinsId: res.CheckinId,
              departmentId: res.DepartmentId,
            });
            this.inputCardValue = "";
          })
          .catch(() => {
            this.isSubmiting = false;
          });
      }
    },
    handleRemoveCard(index) {
      this.cardList.splice(index, 1);
      this.$pub.setS("settleHandList", this.cardList);
    },
    handleBindCard() {
      this.$pub.setS("settleHandList", this.cardList);
      const checkinsIdArr = this.cardList.map((item) => item.checkinsId);
      const depart = this.cardList[0].departmentId;
      this.$router.push({
        name: "HandCardPay",
        query: {
          depart,
          checkinsIdStr: checkinsIdArr.join(","),
        },
      });
    },
    handleBindCardByRoom() {
      this.$router.push({
        name: "HandCardPay",
        query: {
          vpncode: "QHCFZD",
          roomcode: 8,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.search_con {
  display: flex;
  align-items: center;
  background: #fff;
  padding-right: 20px;
}
.card_list_con {
  height: calc(100vh - 240px);
  margin-top: 12px;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;

  .card-view-item {
    padding: 25px;
    background: rgba(235, 220, 192, 0.2);
    border-radius: 30px;
    color: #573500;
    margin-bottom: 20px;

    img {
      width: 40px;
      height: 40px;
      // margin-right: 5px;
      vertical-align: -6px;
    }
  }
}
.card_footer {
  @include fixed-bottom-box-con;
}
</style>
